export default __webpack_public_path__ + "static/fs-673cda4b43bb4d57e46264a207712a1d.png";